import i18n from 'i18next'; 

export const translate = (key: string) => {
  return i18n.t(key);
};